import { monthDifference } from '@applyboard/ui-utils';
import { convertTimelessDateStrToLocalDate } from "../../../utils/dates";
export function validateEslIntake(_ref) {
  var eslIntake = _ref.eslIntake,
    eslProgram = _ref.eslProgram,
    academicIntake = _ref.academicIntake;
  if (!academicIntake || !eslIntake) {
    return true;
  }
  var eslIntakeStartDate = convertTimelessDateStrToLocalDate(eslIntake);
  var academicIntakeStartDate = convertTimelessDateStrToLocalDate(academicIntake);
  var difference = Math.abs(monthDifference(eslIntakeStartDate, academicIntakeStartDate));
  if (!(eslProgram !== null && eslProgram !== void 0 && eslProgram.minLength)) {
    if (eslIntakeStartDate > academicIntakeStartDate) {
      return "ESL intake must not be after Academic intake";
    } else {
      return true;
    }
  }
  if (difference < eslProgram.minLength || eslIntakeStartDate > academicIntakeStartDate) {
    return "ESL intake must be at-least ".concat(eslProgram.minLength, " months before Academic intake");
  }
  return true;
}